import {formatPhoneNumber} from 'platform/locale';

import {join, pipe, reject} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

const joinValuesToString = pipe(reject(isNilOrEmpty), join(' '));

export const getServiceCaseContactPhoneNumber = (
  prefix: string | Nullish,
  number: string | Nullish
) => {
  const joinedPhoneNumber = joinValuesToString([prefix, number]);

  return isNilOrEmpty(joinedPhoneNumber)
    ? undefined
    : (formatPhoneNumber(joinedPhoneNumber) ?? joinedPhoneNumber);
};
